/* istanbul ignore file */
import {
  makeStyles, shorthands, tokens, typographyStyles,
} from '@fluentui/react-components';

export const useContentNoResultStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
  noResultsImage: {
    width: '280px',
    height: '280px',
  },
});

export const useContentStyles = makeStyles({
  root: {
    display: 'flex',
    overflowY: 'hidden',
    ...shorthands.gap(tokens.spacingHorizontalM),
  },
});

export const useDialogContainerStyles = makeStyles({
  surface: {
    maxWidth: '800px',
    height: '80vh',
  },
  body: {
    height: '100%',
  },
  surfaceMobileView: {
    '@media screen and (max-height: 320px)': {
      height: '100%',
    },
  },
});

export const useDialogStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: '100%',
  },
});

export const useListGroupStyles = makeStyles({
  subtitle: {
    ...shorthands.padding(tokens.spacingVerticalS, '44px'),
  },
});

export const useListItemStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalS),
  },
  iconContainer: {
    width: '24px',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: 'inherit',
    ...shorthands.textDecoration('none'),
    ...shorthands.flex(1),

    // When loading the component in ui-next, the focus style isn't applied,
    // so we need to manually add it here.
    '&:focus': {
      outlineOffset: '6px',
      color: 'inherit',
      ...shorthands.borderRadius(tokens.spacingVerticalXXS),
      ...shorthands.outline('2px', 'solid', tokens.colorStrokeFocus2),
      ...shorthands.textDecoration('none'),
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
  },
  title: {
    ...typographyStyles.subtitle2,
    color: tokens.colorBrandForeground1,
  },
  externalIcon: {
    color: tokens.colorBrandForeground1,
  },
  description: {
    ...typographyStyles.body1,
  },
});

export const useListStyles = makeStyles({
  root: {
    height: '100%',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      width: tokens.spacingHorizontalS,
    },
    '&::-webkit-scrollbar-track': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralBackground3,
    },
    '&::-webkit-scrollbar-thumb': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralForeground3,
    },
    '& ::-webkit-scrollbar-thumb:hover': {
      backgroundColor: tokens.colorNeutralForeground3Hover,
    },

    ...shorthands.flex(1),
  },
  divider: {
    ...shorthands.margin(tokens.spacingVerticalS, 0),
  },
});

export const useMenuStyles = makeStyles({
  root: {
    width: '200px',
    ...shorthands.padding(tokens.spacingVerticalXXS, tokens.spacingHorizontalXXS),
  },
  item: {
    textAlign: 'left',
  },
  rootMobileView: {
    '@media screen and (max-width: 480px)': {
      display: 'none',
    },
  },
});
